import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CodemirrorModule } from '@ctrl/ngx-codemirror';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { MomentModule } from 'ngx-moment';
import { TableModule } from 'primeng/table';
import { TabMenuModule } from 'primeng/tabmenu';
import { TabViewModule } from 'primeng/tabview';
import { AppointmentListService } from '../appointment-list/state/appointment-list.service';
import { AppointmentLogDetailsComponent } from './appointment-log-details.component';
import { AppointmentLogEventLogComponent } from './appointment-log-event-log.component';
import { AppointmentLogComponent } from './appointment-log.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TooltipModule.forRoot(),
        TabMenuModule,
        TabsModule,
        RouterModule,
        CodemirrorModule,
        MomentModule,
        TableModule,
        TabViewModule

    ],
    declarations: [
        AppointmentLogComponent,
        AppointmentLogDetailsComponent,
        AppointmentLogEventLogComponent,
    ],
    providers: [
        AppointmentListService
    ]
})
export class AppointmentLogModule {
}
